import { enqueueLog } from './logQueue';

/**
 * logEvent
 * The one function step files call to record a journey-log event. Wraps
 * enqueueLog with a fixed, readable argument shape so every call site
 * across the codebase looks the same (see plan sections 2–4).
 *
 * sessionSlug/hostEmail are NOT passed here — they're attached once per
 * batch by the queue module itself (via setLoggerContext), not per event.
 *
 * Example:
 *   logEvent('connect-pms', LOG_EVENT_TYPE.BUTTON_CLICK, { action: 'CONNECT_PMS' });
 *
 *   logEvent('connect-pms', LOG_EVENT_TYPE.API_ERROR, {
 *     action: 'CONNECT_PMS',
 *     status: LOG_STATUS.FAILED,
 *     requestId,
 *     errorCode: 'PMS_TIMEOUT',
 *     errorMessage: 'Connection attempt timed out',
 *     metadata: { pms: 'hostaway', durationMs: 22000 },
 *   });
 */
const logEvent = (screen, eventType, {
  action = null,
  status = null,
  requestId = null,
  errorCode = null,
  errorMessage = null,
  metadata = {},
} = {}) => {
  enqueueLog({ screen, eventType, action, status, requestId, errorCode, errorMessage, metadata });
};

export default logEvent;
